export default "__VITE_ASSET__6e0716c5__"